<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
    @on-close="handleMsgBoxClose"
  >
    <p slot="header">
      <span class="model-header">我的队伍(限3-5人组队)</span>
    </p>
    <div>
      <h-description :column="1">
        <h-description-item
          :label-width="96"
          label="队伍名称"
          :contextWrap="false"
          >{{ teamInfo.team_name }}</h-description-item
        >
        <h-description-item
          :label-width="96"
          label="队长姓名"
          :contextWrap="false"
          >{{ captainInfo.emp_name || '-' }}</h-description-item
        >
        <h-description-item
          :label-width="96"
          label="工作单位"
          :contextWrap="false"
          >{{ captainInfo.subordinate_company || '-' }}</h-description-item
        >
        <h-description-item
          :label-width="96"
          label="所在子公司/部门"
          :contextWrap="false"
          >{{ captainInfo.emp_post || '-' }}</h-description-item
        >
        <h-description-item
          :label-width="96"
          label="当前队员"
          :contextWrap="false"
        >
          <span class="team-items" v-if="teamInfo.team_members">
            <h-tooltip
              class="mate-item"
              placement="top"
              v-for="(item, index) in teamInfo.team_members"
              :key="item.emp_name"
            >
              <span :class="['mate-name', 'mate-' + index]">
                <span class="captain-tag" v-if="item.captain"
                  ><span>队长</span></span
                >
                {{ item.emp_name.substr(-2) }}</span
              ><span
                class="mate-romove"
                @click="removeMate(item)"
                v-show="!item.captain && competeUser.captain"
                >x</span
              >
              <div slot="content">
                <p style="color: #fff">{{ item.emp_name }}</p>
                <p style="color: #fff">{{ item.emp_id }}</p>
                <p style="color: #fff">{{ item.emp_post }}</p>
              </div>
            </h-tooltip>
            <span
              class="mate-add"
              @click="inviteMate"
              v-show="
                competeUser.captain &&
                teamInfo.team_members &&
                teamInfo.team_members.length < 5
              "
            >
              <h-icon name="add" class="add-icon"></h-icon>
            </span>
          </span>
        </h-description-item>
      </h-description>
    </div>
    <div slot="footer">
      <!-- 未完成组队的情况下，可解散队伍 -->
      <comp-button
        type="default"
        class="btn-icon"
        @click="handleReleaseTeam"
        v-show="
          competeUser.current_team &&
          competeUser.current_team.team_state === '0' &&
          competeUser.captain
        "
        >解散队伍</comp-button
      >
      <comp-button
        class="btn-icon"
        @click="finishFormTeam"
        v-show="competeUser.captain"
        >完成组队</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import { HDescription, HDescriptionItem } from '@/components/HDescription'
import Api from '@/api/competition/financialIndex'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MyTeam',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    CompButton,
    HDescription,
    HDescriptionItem
  },
  computed: {
    ...mapGetters(['competeUser', 'captainInfo', 'teamInfo'])
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    ...mapActions(['getEmpTeam', 'GetCompeteUser']),
    handleMsgBoxClose() {
      this.$emit('stateChange', '')
    },
    inviteMate() {
      Api.inviteUrl().then(
        ({ error_code, data, error_info }) => {
          if (error_code === '0') {
            this.$emit('stateChange', 'inviteTeamMate', {
              teamName: this.teamInfo.team_name,
              url: `${location.origin}/openplat-front/financial-competition?teamId=${data}`
            })
          } else {
            this.$hMessage.info(error_info)
          }
        },
        (err) => {}
      )
    },
    // 处理解散队伍
    handleReleaseTeam() {
      this.showModal = false
      this.$hMsgBox.confirm({
        title: '',
        content: '确定要解散该队伍吗？',
        onOk: () => {
          Api.disbandCompetTeam().then(({ error_code, error_info }) => {
            if (error_code === '0') {
              this.GetCompeteUser()
            } else {
              this.$hMessage.error(error_info)
            }
          })
        }
      })
    },
    // 完成组队
    finishFormTeam() {
      Api.updateCompetTeamStatus('1').then(
        ({ error_code, error_info }) => {
          if (error_code === '0') {
            this.$emit('stateChange', 'myTeamCheck')
          } else {
            this.$hMessage.error(error_info)
          }
        },
        (err) => {}
      )
    },
    removeMate(item) {
      this.$store.commit('SET_DEL_MATE', item)
      this.$emit('stateChange', 'removeTeamMate')
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
      if (newValue) {
        this.getEmpTeam()
      }
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.team-items {
  display: flex;
  .mate-item {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    position: relative;
    margin-right: 10px;
    margin-top: 5px;
    &:hover .mate-romove {
      opacity: 1;
    }
    .mate-name {
      position: relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
        Verdana, 'PingFang SC';
      font-size: 12px;
      color: #fff;
      cursor: pointer;
      white-space: nowrap;
      // overflow: hidden;
      text-overflow: ellipsis;
      &.mate-0 {
        background: #3060ff;
      }
      &.mate-1 {
        background: #1cb77b;
      }
      &.mate-2 {
        background: #ff791a;
      }
      &.mate-3 {
        background: #006600;
      }
      &.mate-4 {
        background: #993399;
      }
    }
    .captain-tag {
      position: absolute;
      width: 24px;
      height: 24px;
      background: url('~@/assets/financialCompetition/captain_bg.png')
        center/contain no-repeat;
      right: -4px;
      top: -9px;
      font-size: 12px;
      color: #fff;
      font-weight: 400;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        display: inline-block;
        transform-origin: center;
        transform: scale(0.5);
      }
    }
    .mate-romove {
      display: inline-block;
      opacity: 1;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #666;
      color: #fff;
      font-size: 12px;
      line-height: 11px;
      text-align: center;
      cursor: pointer;
      position: absolute;
      top: -2px;
      right: -2px;
      .close-icon {
        font-size: 2px;
      }
    }
  }
  .mate-add {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    border: dashed 1px #999;
    cursor: pointer;
    margin-top: 5px;
    .add-icon {
      color: #999;
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/MyTeam/MyTeam.vue